// extracted by mini-css-extract-plugin
export default {"container":"body_container__WxSRz","body":"body_body__lO5Rj"};